// components/Vision.js (actualizado - gradiente azul)
import React from 'react';
import ScrollAnimation from './ScrollAnimation';

const Vision = () => {
    return (
        <section className="py-16 bg-gradient-to-r from-gray-800 to-cyan text-white">
            <div className="container mx-auto px-6 text-center">
                <ScrollAnimation>
                    <h2 className="text-3xl font-bold font-poppins mb-6">Nuestra visión</h2>
                </ScrollAnimation>
                <ScrollAnimation delay={0.3}>
                    <p className="text-xl max-w-3xl mx-auto font-lato">
                        Queremos ser referentes en el desarrollo de tecnología aplicada al fortalecimiento del sector público, impulsando la modernización, la participación y la eficiencia estatal a través del software.
                    </p>
                </ScrollAnimation>
            </div>
        </section>
    );
};

export default Vision;
